import { Grid, Theme, Typography, createStyles, makeStyles } from '@forgeglobal/design-framework'
import { campaignFilterOptions } from 'util/Enums'
import React, { Fragment } from 'react'

import { CampaignCard } from 'components/campaigns/CampaignCard'
import { useGetAllOfferingsQuery } from 'graphql/bindings/AdminBindings'

const useStyles = makeStyles(({ spacing, palette }: Theme) =>
  createStyles({
    actionMenu: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    sliderIcon: {
      color: palette.text.secondary,
      marginRight: spacing(2),
    },
    filterHeader: {
      borderLeft: `2px solid ${palette.divider}`,
      paddingLeft: spacing(2),
    },
    filterActions: {
      display: 'flex',
      alignItems: 'center',
    },
    list: {
      padding: spacing(2, 0),
    },
  })
)

const CampaignCardList: React.FC<{ filter: string }> = ({ filter }) => {
  const getFilterLabel = (filter: string) => {
    for (const option of campaignFilterOptions) {
      const { label, value } = option
      if (value === filter) {
        return label
      }
    }
  }

  const classes = useStyles()

  const { data } = useGetAllOfferingsQuery()
  const campaigns = data?.allOfferings?.data ?? []
  campaigns.sort((a, b) => (a.available_to > b.available_to ? -1 : 1))

  const filteredCampaigns = campaigns.filter(campaign => {
    switch (filter) {
      case 'all':
        return campaign.status !== 'Draft' && campaign.status !== 'Upcoming'
      case 'active':
        return campaign.status === 'Live'
      case 'closed':
        return campaign.status === 'Expired'
      default:
        return false
    }
  })

  return (
    <Fragment>
      <div className={classes.actionMenu}>
        <div className={classes.filterActions}>
          {/* <SlidersHIcon className={classes.sliderIcon} /> -- to use this also use
              className={classes.filterHeader} on Typography element below */}
          <Typography variant="h6" color="secondary">
            {getFilterLabel(filter)}
          </Typography>
        </div>
        <Typography>{filteredCampaigns.length} total</Typography>
      </div>
      <Grid className={classes.list} container spacing={4}>
        {filteredCampaigns.map((campaign, index) => {
          return (
            <Grid item sm={6} md={6} key={`${campaign.name}${index}`}>
              <CampaignCard offering={campaign} />
            </Grid>
          )
        })}
      </Grid>
    </Fragment>
  )
}

export { CampaignCardList }
